import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import type { EmberChangeset } from 'ember-changeset';
import { or } from 'ember-truth-helpers';
// @ts-expect-error Ignoring UIKit type errors
import changesetGet from 'ember-changeset/helpers/changeset-get';
// @ts-expect-error Ignoring UIKit type errors
import changesetSet from 'ember-changeset/helpers/changeset-set';
import BasicRadio, {
  type Signature as BasicRadioSig
} from '../basic-radio.gts';

export interface S {
  Args: Pick<
    BasicRadioSig['Args'],
    | 'propertyName'
    | 'value'
    | 'label'
    | 'translationKey'
    | 'disabled'
    | 'dataTestValue'
    | 'isReadOnly'
    | 'current'
  > & { changeset: EmberChangeset };
}

const ChangesetBasicRadio: TOC<S> = <template>
  <BasicRadio
    @propertyName={{@propertyName}}
    @value={{@value}}
    @label={{@label}}
    @translationKey={{@translationKey}}
    @disabled={{@disabled}}
    @dataTestValue={{@dataTestValue}}
    @isReadOnly={{@isReadOnly}}
    @current={{or @current (changesetGet @changeset @propertyName)}}
    @onChange={{fn (changesetSet @changeset @propertyName)}}
  />
</template>;

export default ChangesetBasicRadio;
